import React, { useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import { useRecoilState } from "recoil";
import Header from "../../component/header";
import Background from "../../component/background";
import InputSpinner from "../../component/inputSpinner";
import { createApprobation } from "../../action/authAction";

import { tokenState, userState } from "../../reducer/recoil";
const { width, height } = Dimensions.get("window");

export default function index({ navigation, route }) {
  const [profile, setProfile] = useRecoilState(userState);
  const [token, setToken] = useRecoilState(tokenState);
  const [state, setState] = useState({
    approbation_details: null,
    approbation_remark: "",
    approbation_type: "Prelim",
    association_id:
      profile.profile != undefined
        ? profile.profile.Association.association_id
        : 0,
    competition_id: route.params.competition_id,
  });
  const [appro, setAppro] = useState({
    competition_id: route.params.competition_id,
    athlete_male_numbers: 0,
    athlete_female_numbers: 0,
    official_male_numbers: 0,
    official_female_numbers: 0,
    room_requests: {},
    events_male: {},
    events_female: {},
    association_id:
      profile.profile != undefined
        ? profile.profile.Association.association_id
        : 0,
    condition_acceptance: true,
  });
  const [events_male, setEvents_male] = useState({});
  const [events_female, setEvents_female] = useState({});
  console.log("params", route.params);
  async function onRegis() {
    let body = state;
    let approbation_Body = appro;
    approbation_Body.events_male = events_male;
    approbation_Body.events_female = events_female;
    body.approbation_details = appro;

    // console.log(body);
    navigation.navigate("PrelimEntryCheck", {
      body,
      token: token.token,
      name: route.params.name,
    });
  }

  return (
    <View style={styles.container}>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorCompetition="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITIONS/${route.params.name}/PRELIMINARY ENTRY SUBMIT`}
          />
          <View
            style={
              width >= 1280 ? styles.viewDetail : stylesResponsive.viewDetail
            }
          >
            <Text
              style={
                width >= 1280 ? styles.textTitle : stylesResponsive.textTitle
              }
            >
              PRELIMINARY ENTRY SUBMIT
            </Text>
            <Text
              style={[
                width >= 1280 ? styles.textTitle : stylesResponsive.textTitle,
                { marginTop: 25 },
              ]}
            >
              ATHLETE
            </Text>
            <View style={{ flexDirection: "row" }}>
              <Text
                style={
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail
                }
              >
                MALE
              </Text>
              <InputSpinner
                setValue={(e) => {
                  console.log(e);
                  setAppro({
                    ...appro,
                    athlete_male_numbers: e,
                  });
                }}
              />
              <Text
                style={
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail
                }
              >
                FEMALE
              </Text>
              <InputSpinner
                setValue={(e) => {
                  console.log(e);
                  setAppro({
                    ...appro,
                    athlete_female_numbers: e,
                  });
                }}
              />
            </View>
            <Text
              style={[
                width >= 1280 ? styles.textTitle : stylesResponsive.textTitle,
                { marginTop: 34 },
              ]}
            >
              OFFICIAL
            </Text>
            <View style={{ flexDirection: "row" }}>
              <Text
                style={
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail
                }
              >
                MALE
              </Text>
              <InputSpinner
                setValue={(e) => {
                  console.log(e);
                  setAppro({
                    ...appro,
                    official_male_numbers: e,
                  });
                }}
              />
              <Text
                style={
                  width >= 1280
                    ? styles.textDetail
                    : stylesResponsive.textDetail
                }
              >
                FEMALE
              </Text>
              <InputSpinner
                setValue={(e) => {
                  console.log(e);
                  setAppro({
                    ...appro,
                    official_female_numbers: e,
                  });
                }}
              />
            </View>
            <Text
              style={[
                width >= 1280 ? styles.textTitle : stylesResponsive.textTitle,
                { marginTop: 37 },
              ]}
            >
              ROOM REQUEST
            </Text>
            {
              <View style={{ flexDirection: width >= 1280 ? "row" : "column" }}>
                {route.params.room_type_request.filter((item) => item == 1)
                  .length > 0 && (
                  <Text
                    style={
                      width >= 1600
                        ? styles.textDetail
                        : stylesResponsive.textDetail
                    }
                  >
                    SINGLE BEDDED ROOM
                  </Text>
                )}
                {route.params.room_type_request.filter((item) => item == 1)
                  .length > 0 && (
                  <InputSpinner
                    setValue={(e) => {
                      console.log(e);
                      setAppro((val) => ({
                        ...val,
                        room_requests: { ...val.room_requests, single: e },
                      }));
                    }}
                  />
                )}
                {route.params.room_type_request.filter((item) => item == 2)
                  .length > 0 && (
                  <Text
                    style={
                      width >= 1600
                        ? styles.textDetail
                        : stylesResponsive.textDetail
                    }
                  >
                    TWIN BEDDED ROOM
                  </Text>
                )}
                {route.params.room_type_request.filter((item) => item == 2)
                  .length > 0 && (
                  <InputSpinner
                    setValue={(e) => {
                      console.log(e);
                      setAppro({
                        ...appro,
                        room_requests: { ...appro.room_requests, twin: e },
                      });
                    }}
                  />
                )}
                {route.params.room_type_request.filter((item) => item == 3)
                  .length > 0 && (
                  <Text
                    style={
                      width >= 1600
                        ? styles.textDetail
                        : stylesResponsive.textDetail
                    }
                  >
                    TRIPPLE BEDDED ROOM
                  </Text>
                )}
                {route.params.room_type_request.filter((item) => item == 3)
                  .length > 0 && (
                  <InputSpinner
                    setValue={(e) => {
                      console.log(e);
                      setAppro({
                        ...appro,
                        room_requests: { ...appro.room_requests, tripple: e },
                      });
                    }}
                  />
                )}
                {route.params.room_type_request.filter((item) => item == 4)
                  .length > 0 && (
                  <Text
                    style={
                      width >= 1600
                        ? styles.textDetail
                        : stylesResponsive.textDetail
                    }
                  >
                    QUADRUBLE ROOM
                  </Text>
                )}
                {route.params.room_type_request.filter((item) => item == 4)
                  .length > 0 && (
                  <InputSpinner
                    setValue={(e) => {
                      console.log(e);
                      setAppro({
                        ...appro,
                        room_requests: { ...appro.room_requests, quad: e },
                      });
                    }}
                  />
                )}
              </View>
            }
            <View style={styles.viewTopic} />
            <Text
              style={[
                width >= 1280 ? styles.textTitle : stylesResponsive.textTitle,
                { marginTop: 20 },
              ]}
            >
              EVENTS
            </Text>
            <Text
              style={[
                width >= 1280 ? styles.textDetail : stylesResponsive.textDetail,
                { marginVertical: 10, paddingTop: 10 },
              ]}
            >
              MALE
            </Text>
            <FlatList
              data={route.params.events_male}
              scrollEnabled={width >= 1280 ? false : true}
              numColumns={width >= 1280 ? 4 : 1}
              renderItem={({ index, item }) => {
                return (
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      style={
                        width >= 1600
                          ? styles.textDetail
                          : stylesResponsive.textDetail
                      }
                    >
                      {item}
                    </Text>
                    {profile.profile != undefined && (
                      <InputSpinner
                        max={100}
                        setValue={(e) => {
                          let obj = events_male;
                          obj[item] = e;
                          setEvents_male(obj);
                        }}
                        event
                      />
                    )}
                  </View>
                );
              }}
            />
            <Text
              style={[
                width >= 1280 ? styles.textDetail : stylesResponsive.textDetail,
                { marginVertical: 10, paddingTop: 10 },
              ]}
            >
              FEMALE
            </Text>
            <FlatList
              data={route.params.events_female}
              scrollEnabled={width >= 1280 ? false : true}
              numColumns={width >= 1280 ? 4 : 1}
              renderItem={({ index, item }) => {
                return (
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      style={
                        width >= 1600
                          ? styles.textDetail
                          : stylesResponsive.textDetail
                      }
                    >
                      {item}
                    </Text>
                    {profile.profile != undefined && (
                      <InputSpinner
                        max={100}
                        setValue={(e) => {
                          let obj = events_female;
                          obj[item] = e;
                          setEvents_female(obj);
                        }}
                        event
                      />
                    )}
                  </View>
                );
              }}
            />
            <TouchableOpacity onPress={onRegis} style={styles.buttonNext}>
              <Text style={styles.textNext}>NEXT</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#CCE4FF",
    flexDirection: "row",
  },
  textTitle: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDetail: {
    fontSize: 16,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 12,
  },
  viewDetail: {
    width: "90%",
    backgroundColor: "#FFFFFF",
    borderRadius: 45,
    alignSelf: "center",
    paddingHorizontal: 37,
    paddingTop: 39,
    marginVertical: 44,
    marginBottom: 36,
  },
  detailNumber: {
    marginHorizontal: width * 0.05,
    width: width * 0.015,
    textAlign: "center",
  },
  viewTopic: {
    width: "100%",
    alignSelf: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#2B6AB1",
    marginVertical: 35,
  },
  buttonNext: {
    width: 108,
    height: 40,
    backgroundColor: "#2B6AB1",
    borderRadius: 10,
    justifyContent: "center",
    marginTop: 64,
    marginBottom: 56,
    alignSelf: "center",
  },
  textNext: {
    fontSize: 20,
    fontFamily: "Prompt",
    color: "#FFFFFF",
    alignSelf: "center",
  },
});
const stylesResponsive = StyleSheet.create({
  viewDetail: {
    width: "90%",
    backgroundColor: "#FFFFFF",
    borderRadius: 45,
    alignSelf: "center",
    paddingHorizontal: 15,
    paddingTop: 39,
    marginVertical: 44,
    marginBottom: 36,
  },
  textTitle: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
  },
  textDetail: {
    fontSize: 14,
    fontFamily: "Prompt",
    color: "#2B6AB1",
    marginTop: 12,
  },
});
